import { createFileRoute } from '@tanstack/react-router'
import { InvitePage } from '@/features/auth'

export const Route = createFileRoute('/auth/(auth)/invite')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    invitationToken:
      typeof search.invitationToken === 'string'
        ? search.invitationToken
        : undefined,
  }),
  component: InviteRoute,
})

function InviteRoute() {
  const { token, invitationToken } = Route.useSearch()
  return <InvitePage token={token} invitationToken={invitationToken} />
}
